<script setup>
import { useSearchStore } from '@/stores/searchStore';
import { DxCheckBox } from 'devextreme-vue';

const store = useSearchStore();

function onToggle(e) {
  const targetItem = e.target.closest('.let-accordion-item');

  //If any boxes are checked we will not close the accordion item
  const checkedBoxes = targetItem.querySelectorAll('input[value="true"]');
  if (checkedBoxes.length > 0) return;

  //Toggle current item
  targetItem.classList.toggle('let-accordion-item-expanded');
}
</script>

<template>
  <div class="filter-container">
    <div class="let-accordion-container">
      <div class="let-accordion-item">
        <div class="let-accordion-item-header" @click="onToggle">
          <div class="let-accordion-item-header-content">Type</div>
          <div class="let-accordion-item-header-open-icon">
            <i class="dx-icon-add"></i>
          </div>
        </div>
        <div class="let-accordion-item-content">
          <div class="let-accordion-item-content-inner">
            <div class="let-accordion-item-content-styling filter-form">
              <DxCheckBox
                text="Nyheder"
                v-model:value="store.filter.opslagType.nyhed.checked"
                @value-changed="store.applyFilter"
              />
              <DxCheckBox
                text="Vejledninger"
                v-model:value="store.filter.opslagType.vejledning.checked"
                @value-changed="store.applyFilter"
              />
              <DxCheckBox
                text="Indholdssider på Letguide"
                v-model:value="store.filter.opslagType.indhold.checked"
                @value-changed="store.applyFilter"
              />
              <DxCheckBox
                text="Produktbeskrivelser"
                v-model:value="store.filter.opslagType.produktbeskrivelse.checked"
                @value-changed="store.applyFilter"
              />
              <DxCheckBox
                text="Q&A's"
                v-model:value="store.filter.opslagType.qa.checked"
                @value-changed="store.applyFilter"
              />
              <DxCheckBox
                text="Diverse materialer (afkastrapporter, faktaark, produktpræsentationer mv.)"
                v-model:value="store.filter.dokumentType.diverse.checked"
                @value-changed="store.applyFilter"
              />
              <DxCheckBox
                text="Brevskabeloner og blanketter"
                v-model:value="store.filter.dokumentType.skabelon.checked"
                @value-changed="store.applyFilter"
              />
              <DxCheckBox
                text="Forsikringsbetingelser"
                v-model:value="store.filter.dokumentType.forsikringsbetingelser.checked"
                @value-changed="store.applyFilter"
              />
              <DxCheckBox
                text="Kundebreve"
                v-model:value="store.filter.dokumentType.kundebreve.checked"
                @value-changed="store.applyFilter"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="let-accordion-item">
        <div class="let-accordion-item-header" @click="onToggle">
          <div class="let-accordion-item-header-content">Produkt</div>
          <div class="let-accordion-item-header-open-icon">
            <i class="dx-icon-add"></i>
          </div>
        </div>
        <div class="let-accordion-item-content">
          <div class="let-accordion-item-content-inner">
            <div class="let-accordion-item-content-styling filter-form">
              <DxCheckBox
                text="Livrente"
                v-model:value="store.filter.tag.livrente.checked"
                @value-changed="store.applyFilter"
              />
              <DxCheckBox
                text="Risikodækninger - død"
                v-model:value="store.filter.tag.doed.checked"
                @value-changed="store.applyFilter"
              />
              <DxCheckBox
                text="Risikodækninger - sygdom + helbred"
                v-model:value="store.filter.tag.sygdom.checked"
                @value-changed="store.applyFilter"
              />
              <DxCheckBox
                text="Letsikring til selvstændige"
                v-model:value="store.filter.tag.lts.checked"
                @value-changed="store.applyFilter"
              />
              <DxCheckBox
                text="Depotsikring"
                v-model:value="store.filter.tag.depotsikring.checked"
                @value-changed="store.applyFilter"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="let-accordion-item">
        <div class="let-accordion-item-header" @click="onToggle">
          <div class="let-accordion-item-header-content">Tema</div>
          <div class="let-accordion-item-header-open-icon">
            <i class="dx-icon-add"></i>
          </div>
        </div>
        <div class="let-accordion-item-content">
          <div class="let-accordion-item-content-inner">
            <div class="let-accordion-item-content-styling filter-form">
              <DxCheckBox
                text="§ 41"
                v-model:value="store.filter.tag.p41.checked"
                @value-changed="store.applyFilter"
              />
              <DxCheckBox
                text="Begunstigelse"
                v-model:value="store.filter.tag.begunstigelse.checked"
                @value-changed="store.applyFilter"
              />
              <DxCheckBox
                text="Priser og omkostninger"
                v-model:value="store.filter.tag.priser.checked"
                @value-changed="store.applyFilter"
              />
              <DxCheckBox
                text="Helbredsoplysninger"
                v-model:value="store.filter.tag.helbred.checked"
                @value-changed="store.applyFilter"
              />
              <DxCheckBox
                text="Afkast, investering, KundeKapital"
                v-model:value="store.filter.tag.afkast.checked"
                @value-changed="store.applyFilter"
              />
              <DxCheckBox
                text="Produktinfo"
                v-model:value="store.filter.tag.produktinfo.checked"
                @value-changed="store.applyFilter"
              />
              <DxCheckBox
                text="Uddannelse"
                v-model:value="store.filter.tag.uddannelse.checked"
                @value-changed="store.applyFilter"
              />
              <DxCheckBox
                text="Opsigelse"
                v-model:value="store.filter.tag.opsigelse.checked"
                @value-changed="store.applyFilter"
              />
              <DxCheckBox
                text="Varslinger"
                v-model:value="store.filter.tag.varslinger.checked"
                @value-changed="store.applyFilter"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="let-accordion-item">
        <div class="let-accordion-item-header" @click="onToggle">
          <div class="let-accordion-item-header-content">År</div>
          <div class="let-accordion-item-header-open-icon">
            <i class="dx-icon-add"></i>
          </div>
        </div>
        <div class="let-accordion-item-content">
          <div class="let-accordion-item-content-inner">
            <div class="let-accordion-item-content-styling filter-form">
              <DxCheckBox
                v-for="aar in store.filter.aar"
                :key="aar.aarstal"
                :text="aar.aarstal"
                v-model:value="aar.checked"
                @value-changed="store.applyFilter"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/css/variables.letguide.scss';

.search-tools {
  text-align: right;
}

.filter-header {
  font-weight: 600;
}

.filter-section-header {
  font-weight: 500;
  // color: #666666;
}

.filter-form {
  display: flex;
  gap: 4px;
  flex-direction: column;
}

.icon {
  height: 24px;
  cursor: pointer;
  margin-right: 10px;
}
</style>
